import React, { useEffect } from 'react';
import {
  subscribeToPush,
  registerServiceWorker,
  requestPermissionThenSubscribe,
  unsubscribeFromPush,
  notifyMe,
  syncSubscriptionWithServer,
} from './push-notification';

// Функция для проверки совместимости браузера
function checkBrowserCompatibility() {
  const compatibility = {
    notification: 'Notification' in window,
    serviceWorker: 'serviceWorker' in navigator,
    pushManager: 'PushManager' in window,
    secureContext: window.isSecureContext,
    userAgent: navigator.userAgent,
    isSupported: false,
    // Мобильная диагностика
    isMobile: /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
    isAndroid: /Android/.test(navigator.userAgent),
    isStandalone: window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches,
    isInApp: /(FBAN|FBAV|Twitter|Instagram|LinkedIn)/i.test(navigator.userAgent),
    chromeVersion: navigator.userAgent.match(/Chrome\/(\d+)/)?.[1],
    safariVersion: navigator.userAgent.match(/Version\/(\d+\.\d+)/)?.[1]
  };
  
  // Определяем общую поддержку
  compatibility.isSupported = 
    compatibility.notification && 
    compatibility.serviceWorker && 
    compatibility.pushManager && 
    compatibility.secureContext;
  
  console.log('🔍 Совместимость браузера:', compatibility);
  
  // Мобильная диагностика
  if (compatibility.isMobile) {
    console.log('📱 Мобильное устройство обнаружено');
    
    if (compatibility.isIOS) {
      console.log('🍎 iOS устройство');
      if (parseInt(compatibility.safariVersion || '0') < 16.4) {
        console.warn('⚠️ iOS Safari < 16.4 имеет ограниченную поддержку пуш-уведомлений');
      }
      if (!compatibility.isStandalone) {
        console.warn('⚠️ На iOS пуш работают только в PWA режиме (Add to Home Screen)');
      }
    }
    
    if (compatibility.isAndroid) {
      console.log('🤖 Android устройство');
      if (parseInt(compatibility.chromeVersion || '0') < 42) {
        console.warn('⚠️ Старая версия Chrome Android');
      }
    }
    
    if (compatibility.isInApp) {
      console.warn('⚠️ Обнаружен встроенный браузер приложения - пуш может не работать');
    }
  }
  
  // Выводим конкретные проблемы
  if (!compatibility.notification) {
    console.warn('❌ Notification API не поддерживается');
  }
  if (!compatibility.serviceWorker) {
    console.warn('❌ Service Worker не поддерживается');
  }
  if (!compatibility.pushManager) {
    console.warn('❌ Push Manager не поддерживается');
  }
  if (!compatibility.secureContext) {
    console.warn('❌ Требуется безопасный контекст (HTTPS)');
  }
  
  return compatibility;
}

async function isUserSubscribed() {
  if (!('serviceWorker' in navigator)) {
    console.error('Service workers are not supported in this browser.');
    return false;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    return subscription !== null; // Returns true if the user is already subscribed
  } catch (error) {
    console.error('Error checking subscription status:', error);
    return false;
  }
}

function NotificationComponent() {
  useEffect(() => {
    console.log('Test pushh1');
    // Ensure SW is registered as early as possible in dev
    registerServiceWorker();
    
    // Проверяем совместимость браузера
    const compatibility = checkBrowserCompatibility();
    
    // Детальная диагностика окружения
    console.log('window объект:', typeof window !== 'undefined');
    console.log('Notification в window:', 'Notification' in window);
    console.log('Notification конструктор:', typeof Notification);
    console.log('User Agent:', navigator.userAgent);
    console.log('Secure context (HTTPS):', window.isSecureContext);
    console.log('ServiceWorker поддержка:', 'serviceWorker' in navigator);
    console.log('PushManager поддержка:', 'PushManager' in window);
    
    // Ensure Notification API is available
    if ('Notification' in window) {
      if (Notification.permission === 'default') {
        Notification.requestPermission().then(async (permission) => {
          if (permission === 'granted') {
            const alreadySubscribed = await isUserSubscribed();
            if (!alreadySubscribed) {
              subscribeToPush();
            } else {
              console.log('User is already subscribed to push notifications.');
            }
          }
        });
      } else if (Notification.permission === 'granted') {
        // Не автосоздаём новую подписку, чтобы не вызывался Add сразу после Remove
        isUserSubscribed().then((alreadySubscribed) => {
          if (alreadySubscribed) {
            syncSubscriptionWithServer();
            console.log('User is already subscribed to push notifications.');
          }
        });
      }
    } else {
      console.error('This browser does not support notifications.');
      console.error('Возможные причины:');
      console.error('1. Устаревший браузер');
      console.error('2. Режим инкогнито');
      console.error('3. Корпоративные ограничения');
      console.error('4. Небезопасный контекст (HTTP вместо HTTPS)');
      
      // Попробуем определить конкретную причину
      if (typeof window === 'undefined') {
        console.error('Объект window недоступен (SSR?)');
      } else if (!window.isSecureContext) {
        console.error('Небезопасный контекст - требуется HTTPS');
      } else {
        console.error('Notification API не поддерживается браузером');
      }
    }

    // Call updateUI after component mounts (if you need this functionality)
    // updateUI();
  }, []);

  function notifyMee() {
    if (Notification.permission === 'granted') {
      // Customize the notification
      const options = {
        body: 'This is the body text of the notification.',
        icon: 'path_to_icon.png', // URL to an icon image
        image: 'path_to_image.jpg', // URL to an image (for notifications that support it)
        badge: 'path_to_badge.png', // Smaller icon to display on mobile devices
        vibrate: [200, 100, 200], // Vibration pattern for mobile devices
        actions: [
          { action: 'explore', title: 'Go to website' },
          { action: 'close', title: 'Dismiss' },
        ],
        tag: 'example-notification', // Tag to prevent multiple notifications stacking
        renotify: false, // If true, the user is notified even if there's already a notification with the same tag
        data: { url: 'https://yourwebsite.com' }, // Custom data to handle when notification is clicked
      };

      // Show the notification
      const notification = new Notification('Custom Notification Title', options);

      // Handle notification click event
      notification.onclick = (event) => {
        event.preventDefault(); // Prevent default action (e.g., opening a webpage)
        window.open(notification.data.url, '_blank'); // Open a URL when the notification is clicked
      };
    } else if (Notification.permission === 'default' || Notification.permission === 'denied') {
      Notification.requestPermission();
    }
  }

  return (
    <>
      <button id="enable-push" onClick={requestPermissionThenSubscribe} style={{ display: 'none' }}>
        Включить уведомления
      </button>
    </>
  );
}

export default NotificationComponent;
